import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setViewAsRole, useViewAsRole } from "./viewAsRoleStore";

/**
 * The "view as role" preview is a v2 concept. Navigating out of the v2 area exits the preview, so
 * V1 surfaces always show the real roles — and returning to v2 starts from them too.
 */
export const ViewAsRoleScope = () => {
  const { pathname } = useLocation();
  const viewAsRole = useViewAsRole();

  useEffect(() => {
    if (viewAsRole && !pathname.startsWith("/v2")) setViewAsRole(null);
  }, [pathname, viewAsRole]);

  return null;
};
